import { Dispatch } from 'redux';
import { useDispatch, useSelector } from "react-redux"
import { updateInvoiceFormSuccessful } from '../actions/invoice/actionCreators';

function BuyerForm() {
    const invoiceForm: NewInvoiceDetails = useSelector((state: AppState) => state.invoiceForm)
    const dispatch: Dispatch<any> = useDispatch()

    const setItemValue = (e: React.ChangeEvent<HTMLInputElement>, field: string) => {
        const value = e.target.value
        const updatedInvoiceForm: NewInvoiceDetails = { 
            ...invoiceForm,
            [field]: value
        }
        dispatch(updateInvoiceFormSuccessful(updatedInvoiceForm))
    }

    return (
        <>  
            <div className="buyer-form-layout">
                <div className="input-row-container">
                    <div className="input-container">
                        <label className="item"> First Name </label> <br />
                        <input 
                            type="text"
                            name="firstName"
                            className="item"
                            placeholder="First Name"
                            value={invoiceForm.firstName}
                            onChange={(e: React.ChangeEvent<HTMLInputElement>) => setItemValue(e, 'firstName')}
                            required 
                        />
                    </div>
                    <div className="input-container">
                        <label className="item"> Last Name </label> <br />
                        <input 
                            type="text"
                            name="lastName"
                            className="item"
                            placeholder="Last Name"
                            value={invoiceForm.lastName}
                            onChange={(e: React.ChangeEvent<HTMLInputElement>) => setItemValue(e, 'lastName')}
                            required 
                        />
                    </div>
                </div>
                <div className="input-row-container">
                    <div className="input-container">
                        <label className="item"> Email </label> <br />
                        <input 
                            type="email"
                            name="email"
                            className="item"
                            placeholder="Email"
                            value={invoiceForm.email}
                            onChange={(e: React.ChangeEvent<HTMLInputElement>) => setItemValue(e, 'email')}
                            required 
                        />
                    </div>
                    <div className="input-container">
                        <label className="item"> Contact Number </label> <br />
                        <input 
                            type="text"
                            name="phone"
                            className="item"
                            placeholder="Contact Number"
                            value={invoiceForm.phone}
                            onChange={(e: React.ChangeEvent<HTMLInputElement>) => setItemValue(e, 'phone')}
                            required 
                        />
                    </div>
                    <div className="input-container">
                        <label className="item"> Country Code </label> <br />
                        <input 
                            type="text"
                            name="countryCode"
                            className="item"
                            placeholder="Country Code"
                            value={invoiceForm.countryCode}
                            required 
                            disabled
                        />
                    </div>
                </div>
            </div>
        </>
    )
}

export default BuyerForm